export class InvalidDateTimeException extends Error {
  constructor() {
    super();

    this.message = "Improperly formatted date/time";
  }
}
